import { isColdTub } from "./brand";
import { MQTT_PREFIX } from "../services/mqtt/mqttconfig";

/**
 * Public API server docs URL, brand- and environment-aware:
 *   https://api-beta.myarcticspa.com/docs  /  https://api.myarcticspa.com/docs
 *   https://api-beta.mycoldtub.com/docs    /  https://api.mycoldtub.com/docs
 */
export const apiDocsUrl = (): string => {
  const domain = isColdTub ? "mycoldtub.com" : "myarcticspa.com";
  const sub = MQTT_PREFIX.includes("beta") ? "api-beta" : "api";
  return `https://${sub}.${domain}/docs`;
};
